export enum GoalBarChartKeyColors {
    LIFESTYLE = '#52897F',
    FAMILY = '#FFC24B',
    DISCRETIONARY = '#D99131',
    PHILANTHROPIC = '#F1B040',
    TAX_LIABILITIES = '#FFDF77',
}